import { Component } from 'react'
import { t } from 'libs/translationsUtils/translations'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import TopicLabel from './TopicLabel'
import TopicContent from './TopicContent'
import TopicBreadcrumb from './TopicBreadcrumb'
import TopicTooltip from './TopicTooltip'
import TopicReplyCount from '../ui-components/TopicReplyCount'
import TopicViewsCount from '../ui-components/TopicViewsCount'
import TopicListLikeButton from './TopicListLikeButton'
import Analytics from '../analytics/Analytics'

export default class TopicListItem extends Component {
  constructor (props) {
    super(props)

    this.threadClasses = this.threadClasses.bind(this)
    this.eventTopicTrackerHandler = this.eventTopicTrackerHandler.bind(this)
  }

  threadClasses () {
    const { isGuest } = this.props
    const { id, type, isTopicUnread, isSticky, features } = this.props.topic
    let classes = `js-thread js-thread-id-${id} thread--type-${type}`
    classes += isGuest || isTopicUnread ? ' thread--unread' : ''
    classes += isSticky ? ' thread--feature-sticky' : ''
    classes += features.length ? ` thread--feature-${features[0].id.substr(2).toLowerCase()}` : ''

    return classes
  }

  eventTopicTrackerHandler () {
    let type = 'conversation'

    if (this.props.topic.contentType === 'article') {
      type = 'article'
    } else if (this.props.topic.type === 'ideation') {
      type = 'ideation'
    } else if (this.props.topic.features.length) {
      if (this.props.topic.features[0].id === 'isQuestion') {
        type = 'question'
      } else if (this.props.topic.features[0].id === 'isAnswered') {
        type = 'answer'
      }
    }

    const eventLabel = {
      Type: type,
      Position: this.props.tab,
      Link: this.props.topic.url
    }

    Analytics.send('Homepage', 'Topic clicked', eventLabel)

    if (typeof this.props.clickCallback === 'function') {
      this.props.clickCallback(this.props.topic)
    }
  }

  render (props) {
    const { isGuest, topic, attachmentCdn } = props
    const { isSticky, id: topicId, url: topicUrl, title: topicTitle, numberOfViews, numberOfReplies, numberOfUnreadReplies, firstPost, category, forum, lastPost } = topic
    const { author } = firstPost
    const { id: userId, userTitle } = author
    const { categoryId, title: categoryTitle } = category
    const { url: forumUrl, title: forumTitle } = forum
    const { url: lastPostUrl, author: lastPostAuthor, relativeCreationDate: lastPostRelativeCreationDate } = lastPost
    const { hideCategoryMetadata } = props

    return (
      <div class={`qa-topic-block thread-list-item forum-list-view-spacing ${this.threadClasses()}`}>
        {isSticky ? <div class='thread-sticky-flag qa-sticky-flag' /> : null}

        <div class='thread-list-block__avatar-col'>
          <UserAvatar
            user={author}
            extraClass='thread-list-avatar avatar--responsive'
            showRank
          />
        </div>

        <div class='thread-list-block__text-col'>
          <div class='thread-list-block__header qa-topic-block-icon'>
            <UserName
              user={author}
              extraClass='username'
            />

            {userId ? <span class='thread-meta-link-rank'>{userTitle}</span> : ''}
          </div>

          <div className='thread-list-block__link-wrapper' onClick={this.eventTopicTrackerHandler}>
            <h4 className='thread-list-block__title'>
              <TopicLabel
                topic={topic}
              />

              <a
                href={topicUrl}
                className='qa-topic-title thread-list-block__title-link'
              >
                {topicTitle}
              </a>

              <TopicTooltip
                topic={topic}
              />
            </h4>

            <TopicContent
              topic={topic}
              attachmentCdn={attachmentCdn}
            />
          </div>

          {!hideCategoryMetadata && (
            <TopicBreadcrumb
              parentCategoryTitle={categoryTitle}
              parentCategoryUrl={category.url}
              parentCategoryId={categoryId}
              categoryTitle={forumTitle}
              categoryUrl={forumUrl}
            />
          )}

          <div class='thread-list-block__footer qa-topic-meta-icons'>
            <TopicListLikeButton
              topic={topic}
              isGuest={isGuest}
            />

            <span class='thread-meta-item thread-meta-item--hover-highlight is-hidden-S'>
              <a class='qa-topic-meta-views' href={topicUrl}>
                <TopicViewsCount views={numberOfViews} />
              </a>
            </span>

            <span class='thread-meta-item thread-meta-item--comments thread-meta-item--hover-highlight'>
              <a class='qa-topic-meta-replies-icon' href={lastPostUrl}>
                <TopicReplyCount replyCount={numberOfReplies} />
              </a>

              {numberOfUnreadReplies
                ? <span class='thread-meta-item__text thread-meta-bullet'>
                  <span class='icon--bullet icon--auto-width' />
                </span>
                : null}
              {numberOfUnreadReplies
                ? <a
                  class='thread-meta-item__text--highlight qa-topic-meta-new'
                  href={`/topic/firstNewPostRedirect?topicId=${topicId}`}
                >
                  <span class='thread-meta-item__text--highlight'>
                    {t('Forum', 'forumList.meta.counter.post.user.new', { n: numberOfUnreadReplies })}
                  </span>
                </a>
                : null}
            </span>

            <span class='thread-meta-item thread-meta-item--hover-highlight'>
              <UserAvatar
                user={lastPostAuthor}
                extraClass='avatar--XS thread-meta-item__icon'
                showRank
              />

              <a
                class='qa-topic-meta-last-post-date-link'
                href={lastPostUrl}
              >
                <span class='thread-meta-item__text'>
                  {lastPostRelativeCreationDate}
                </span>
              </a>
            </span>
          </div>
        </div>
      </div>
    )
  }
}
